export default {
    isLogin({ profile = {} }) {
        return Object.keys(profile).length !== 0
    },
    /* 购物车中商品数量  */
    cartNumber({ cart =[]}){
        return cart.reduce((acc, item) => acc + item.quantity || 0, 0)
    }
}